export const emeaChartColorPanel = ["#F17B2C"];
export const boxShadow = "0px 12px 20px 0px rgba(0, 0, 0, 0.12)";
export const chartsHeight = 320;
export const laoChartColorPanel = ["#56B1FA"];